import NextHead from 'next/head'

const Breadcrumbs = ({ items }) => {
	return (
		<>
			{items.length > 0 && (
				<NextHead>
					<script
						type="application/ld+json"
						dangerouslySetInnerHTML={{
							__html: JSON.stringify({
								'@context': 'https://schema.org',
								'@type': 'BreadcrumbList',
								itemListElement: items.map(({ label, url }, index) => ({
									'@type': 'ListItem',
									position: index + 1,
									name: label,
									item: url,
								})),
							}),
						}}
					/>
				</NextHead>
			)}
		</>
	)
}

export default Breadcrumbs
